import EventHubMixin from '@/mixins/EventHub.js'
import ScrollMixin from '@/mixins/Scroll.js'
import SizesMixin from '@/mixins/Sizes.js'

import AppIconArrow from '@/components/app-icon-arrow'

export default
{
    name: 'app-header-logo',

    mixins:
    [
        EventHubMixin,
        ScrollMixin,
        SizesMixin
    ],

    components:
    {
        AppIconArrow
    },

    data()
    {
        return {
            state: 'hidden', // 'logo' | 'back' | 'hidden'
            backText: '',
            fixedBack: false,
            backMode: 'default'
        }
    },

    created()
    {
        this.backDefaultMode = null
        this.backTo = null
        this.backEvent = null
        this.prevData = null
        this.currentData = null
        this.fixedLimit = 0
    },

    mounted()
    {
        this.$eventHub.$on('headerLogo.setState', this.setState)
        this.$eventHub.$on('headerLogo.prevState', this.prevState)

        this.onResize()
    },

    methods:
    {
        onScroll()
        {
            this.fixedBack = this.scroll.current > this.fixedLimit

            if(this.backDefaultMode === 'white')
            {
                this.backMode = 'with-background'
            }
            else
            {
                this.backMode = this.scroll.current > this.sizes.height - 30 ? 'with-background' : 'default'
            }
        },

        onResize()
        {
            if(!this.fixedBack)
            {
                const bounding = this.$refs.backContainer.getBoundingClientRect()

                this.fixedLimit = bounding.top + this.scroll.current
            }
            else
            {
                this.fixedBack = false

                this.$nextTick(() =>
                {
                    const bounding = this.$refs.backContainer.getBoundingClientRect()
                    this.fixedLimit = bounding.top + this.scroll.current

                    this.$nextTick(() =>
                    {
                        this.fixedBack = true
                    })
                })
            }
        },

        setState(data)
        {
            this.prevData = this.currentData
            this.currentData = data

            switch(data.state)
            {
                case 'logo':
                    this.state = 'logo'
                    break

                case 'hidden':
                    this.state = 'hidden'
                    break

                case 'back':
                    // Not yet in back state
                    if(this.state !== 'back')
                    {
                        this.state = 'back'

                        if(data.backText)
                        {
                            this.backText = data.backText
                        }

                        this.backDefaultMode = data.backDefaultMode ? data.backDefaultMode : null
                        this.backTo = data.backTo ? data.backTo : null
                        this.backEvent = data.backEvent ? data.backEvent : null

                        this.onScroll()
                    }

                    // Already in back state
                    else
                    {
                        // Text has change
                        if(data.backText !== this.backText)
                        {
                            // Hide then show with new text
                            this.state = this.sizes.width < 1024 ? 'hidden' : 'logo'
                            window.setTimeout(() =>
                            {
                                this.state = 'back'
                                this.backText = data.backText
                                this.backTo = data.backTo ? data.backTo : null
                                this.backDefaultMode = data.backDefaultMode ? data.backDefaultMode : null
                                this.backEvent = data.backEvent ? data.backEvent : null

                                this.onScroll()
                            }, 1000)
                        }
                    }
            }
        },

        prevState()
        {
            if(this.prevData)
            {
                this.setState(this.prevData)
            }
        },

        onClick()
        {
            // Trigger event
            if(this.backEvent)
            {
                this.$eventHub.$emit('headerLogo.click', this.backEvent)
            }

            // Router to
            else if(this.backTo)
            {
                this.$router.push(this.backTo)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-header-logo/script.js